import './cn-page-header.scss';
import * as React from 'react';
export var CnPageHeader = function (props) {
    if (!props.action)
        return null;
    return (React.createElement("div", { className: "cn-ui-m-page-header" },
        React.createElement("div", { className: "cn-ui-m-page-header__action" }, props.action)));
};
